var map = {
	"./img/add-icon--small.svg": 7635,
	"./img/add_image.svg": 4430,
	"./img/addevents-header-icon.svg": 37769,
	"./img/arrow-down.svg": 81074,
	"./img/arrow-up.svg": 1358,
	"./img/back-arrow.svg": 54776,
	"./img/ball.svg": 87092,
	"./img/bar-beverage.svg": 92606,
	"./img/bar-settings.svg": 66639,
	"./img/bg-events.jpg": 59205,
	"./img/calender.svg": 59863,
	"./img/cast.svg": 6579,
	"./img/channels/48pxIcons/Australian/10 bold 1.svg": 49397,
	"./img/channels/48pxIcons/Australian/7Mate Brisbane.svg": 77668,
	"./img/channels/48pxIcons/Australian/7Mate Melbourne.svg": 85555,
	"./img/channels/48pxIcons/Australian/7Mate Sydney.svg": 1638,
	"./img/channels/48pxIcons/Australian/7TWO 1.svg": 14516,
	"./img/channels/48pxIcons/Australian/7TWO Brisbane.svg": 81654,
	"./img/channels/48pxIcons/Australian/7TWO Melbourne.svg": 4559,
	"./img/channels/48pxIcons/Australian/7TWO Perth.svg": 90894,
	"./img/channels/48pxIcons/Australian/7TWO Sydney.svg": 97910,
	"./img/channels/48pxIcons/Australian/7mate Adelaide 1.svg": 57370,
	"./img/channels/48pxIcons/Australian/7mate Perth.svg": 37891,
	"./img/channels/48pxIcons/Australian/9Gem 1.svg": 30165,
	"./img/channels/48pxIcons/Australian/9go 1.svg": 83081,
	"./img/channels/48pxIcons/Australian/ABC 1.svg": 96124,
	"./img/channels/48pxIcons/Australian/ABC QLD.svg": 98515,
	"./img/channels/48pxIcons/Australian/ABC SA.svg": 34643,
	"./img/channels/48pxIcons/Australian/ABC VIC.svg": 57864,
	"./img/channels/48pxIcons/Australian/ABC WA.svg": 73728,
	"./img/channels/48pxIcons/Australian/Australia Plus 1.svg": 32063,
	"./img/channels/48pxIcons/Australian/Channel 10 Brisbane.svg": 31505,
	"./img/channels/48pxIcons/Australian/Channel 10 Melbourne.svg": 29267,
	"./img/channels/48pxIcons/Australian/Channel 10 Perth.svg": 83644,
	"./img/channels/48pxIcons/Australian/Channel 10 Sydney.svg": 75066,
	"./img/channels/48pxIcons/Australian/Channel 10.svg": 25953,
	"./img/channels/48pxIcons/Australian/Channel 7 Brisbane.svg": 4174,
	"./img/channels/48pxIcons/Australian/Channel 7 Melbourne.svg": 5786,
	"./img/channels/48pxIcons/Australian/Channel 7 Perth.svg": 15514,
	"./img/channels/48pxIcons/Australian/Channel 7 Sydney.svg": 97993,
	"./img/channels/48pxIcons/Australian/Channel 7.svg": 92971,
	"./img/channels/48pxIcons/Australian/Channel 9 Brisbane.svg": 44542,
	"./img/channels/48pxIcons/Australian/Channel 9 Melbourne.svg": 49953,
	"./img/channels/48pxIcons/Australian/Channel 9 Perth.svg": 44164,
	"./img/channels/48pxIcons/Australian/Channel 9 Sydney.svg": 23784,
	"./img/channels/48pxIcons/Australian/Channel 9.svg": 22393,
	"./img/channels/48pxIcons/Australian/Chelsea TV.svg": 19777,
	"./img/channels/48pxIcons/Australian/ESPN.svg": 98614,
	"./img/channels/48pxIcons/Australian/ESPN2.svg": 59266,
	"./img/channels/48pxIcons/Australian/Epicentre.TV.svg": 91535,
	"./img/channels/48pxIcons/Australian/Eurosport.svg": 63629,
	"./img/channels/48pxIcons/Australian/Fox Cricket.svg": 83052,
	"./img/channels/48pxIcons/Australian/Fox Footy.svg": 60502,
	"./img/channels/48pxIcons/Australian/Fox League.svg": 82320,
	"./img/channels/48pxIcons/Australian/Fox Sports 503.svg": 7493,
	"./img/channels/48pxIcons/Australian/Fox Sports 505.svg": 76501,
	"./img/channels/48pxIcons/Australian/Fox Sports 506.svg": 9104,
	"./img/channels/48pxIcons/Australian/Fox Sports More.svg": 36007,
	"./img/channels/48pxIcons/Australian/Fox Ultra HD.svg": 12930,
	"./img/channels/48pxIcons/Australian/Kayo Sports.svg": 84345,
	"./img/channels/48pxIcons/Australian/LFCTV.svg": 80497,
	"./img/channels/48pxIcons/Australian/MUTV.svg": 25951,
	"./img/channels/48pxIcons/Australian/Main Event.svg": 17596,
	"./img/channels/48pxIcons/Australian/NITV.svg": 67869,
	"./img/channels/48pxIcons/Australian/Netball Live.svg": 64034,
	"./img/channels/48pxIcons/Australian/Optus sport.svg": 45457,
	"./img/channels/48pxIcons/Australian/RAI Italia.svg": 63987,
	"./img/channels/48pxIcons/Australian/Racing.com.svg": 4649,
	"./img/channels/48pxIcons/Australian/SBS SA.svg": 71162,
	"./img/channels/48pxIcons/Australian/SBS Sydney.svg": 41479,
	"./img/channels/48pxIcons/Australian/SBS Viceland.svg": 98223,
	"./img/channels/48pxIcons/Australian/SBS WA.svg": 93150,
	"./img/channels/48pxIcons/Australian/SBS.svg": 19904,
	"./img/channels/48pxIcons/Australian/SKY Racing 2.svg": 89606,
	"./img/channels/48pxIcons/Australian/SKY Racing.svg": 80832,
	"./img/channels/48pxIcons/Australian/Sport Plus TV.svg": 27794,
	"./img/channels/48pxIcons/Australian/Stan Sport.svg": 79320,
	"./img/channels/48pxIcons/Australian/TV5MONDE Pacific.svg": 63756,
	"./img/channels/48pxIcons/Australian/Telstra TV.svg": 31817,
	"./img/channels/48pxIcons/Australian/beIN SPORTS 2.svg": 53755,
	"./img/channels/48pxIcons/Australian/beIN SPORTS 3.svg": 19097,
	"./img/channels/48pxIcons/Australian/beIN SPORTS.svg": 66213,
	"./img/channels/48pxIcons/Danish/3-Max.svg": 84538,
	"./img/channels/48pxIcons/Danish/3-Plus.svg": 85730,
	"./img/channels/48pxIcons/Danish/3-Sport.svg": 19009,
	"./img/channels/48pxIcons/Danish/6-eren.svg": 93454,
	"./img/channels/48pxIcons/Danish/9-eren.svg": 8205,
	"./img/channels/48pxIcons/Danish/C-More.svg": 59793,
	"./img/channels/48pxIcons/Danish/Canal-8-Sport.svg": 60314,
	"./img/channels/48pxIcons/Danish/DR1.svg": 71122,
	"./img/channels/48pxIcons/Danish/DR2.svg": 16544,
	"./img/channels/48pxIcons/Danish/DR3.svg": 57528,
	"./img/channels/48pxIcons/Danish/Eurosport-1.svg": 41091,
	"./img/channels/48pxIcons/Danish/Eurosport-2.svg": 93411,
	"./img/channels/48pxIcons/Danish/Eurosport-Player.svg": 60498,
	"./img/channels/48pxIcons/Danish/Kanal-5.svg": 99107,
	"./img/channels/48pxIcons/Danish/See.svg": 4579,
	"./img/channels/48pxIcons/Danish/Strive.svg": 44547,
	"./img/channels/48pxIcons/Danish/TV2-Sport.svg": 16080,
	"./img/channels/48pxIcons/Danish/TV2.svg": 25065,
	"./img/channels/48pxIcons/Danish/TV3-Sport-2.svg": 34329,
	"./img/channels/48pxIcons/Danish/Viasat-Golf.svg": 56475,
	"./img/channels/48pxIcons/Danish/Viasat-Xtra.svg": 23358,
	"./img/channels/48pxIcons/Danish/Xee.svg": 34374,
	"./img/channels/48pxIcons/Danish/dPlay.svg": 83672,
	"./img/channels/48pxIcons/Danish/viaplay.svg": 18769,
	"./img/channels/48pxIcons/Finland/C More Golf.svg": 89566,
	"./img/channels/48pxIcons/Finland/C More Max.svg": 53269,
	"./img/channels/48pxIcons/Finland/C More Sport 1.svg": 42363,
	"./img/channels/48pxIcons/Finland/C More Sport 2.svg": 88442,
	"./img/channels/48pxIcons/Finland/Elisa Viihde Sport.svg": 38470,
	"./img/channels/48pxIcons/Finland/Eurosport 2.svg": 37838,
	"./img/channels/48pxIcons/Finland/Eurosport.svg": 6201,
	"./img/channels/48pxIcons/Finland/MTV3.svg": 44511,
	"./img/channels/48pxIcons/Finland/Ruutu+ Urheliu 1.svg": 38842,
	"./img/channels/48pxIcons/Finland/Ruutu+ Urheliu 2.svg": 39755,
	"./img/channels/48pxIcons/Finland/Ruutu+ Urheliu 3.svg": 2683,
	"./img/channels/48pxIcons/Finland/Ruutu+ Urheliu 4.svg": 68280,
	"./img/channels/48pxIcons/Finland/Ruutu+ Urheliu 5.svg": 32495,
	"./img/channels/48pxIcons/Finland/Ruutu+ Urheliu 6.svg": 97664,
	"./img/channels/48pxIcons/Finland/Ruutu+ Urheliu 7.svg": 33221,
	"./img/channels/48pxIcons/Finland/Ruutu+ Urheliu 8.svg": 30186,
	"./img/channels/48pxIcons/Finland/Ruutu+.svg": 86069,
	"./img/channels/48pxIcons/Finland/Sub.svg": 65017,
	"./img/channels/48pxIcons/Finland/Telia.svg": 9241,
	"./img/channels/48pxIcons/Finland/Unibet TV.svg": 77288,
	"./img/channels/48pxIcons/Finland/Viasat Fotboll.svg": 99027,
	"./img/channels/48pxIcons/Finland/Viasat Golf.svg": 71925,
	"./img/channels/48pxIcons/Finland/Viasat Hockey.svg": 68443,
	"./img/channels/48pxIcons/Finland/Viasat Jalkapallo.svg": 54925,
	"./img/channels/48pxIcons/Finland/Viasat Jääkiekko.svg": 22119,
	"./img/channels/48pxIcons/Finland/Viasat Sport Live 1.svg": 84053,
	"./img/channels/48pxIcons/Finland/Viasat Sport Live 2.svg": 47349,
	"./img/channels/48pxIcons/Finland/Viasat Sport Live 3.svg": 2786,
	"./img/channels/48pxIcons/Finland/Viasat Sport Live 4.svg": 10404,
	"./img/channels/48pxIcons/Finland/Viasat Sport Live 5.svg": 86607,
	"./img/channels/48pxIcons/Finland/Viasat Sport Premium.svg": 75185,
	"./img/channels/48pxIcons/Finland/Viasat Sport Ultra HD.svg": 57344,
	"./img/channels/48pxIcons/Finland/Viasat Sport.svg": 9504,
	"./img/channels/48pxIcons/Finland/Viasat Urheilu.svg": 21357,
	"./img/channels/48pxIcons/Finland/YLE Areena.svg": 31127,
	"./img/channels/48pxIcons/Finland/Yle FEM.svg": 59167,
	"./img/channels/48pxIcons/Finland/Yle TV1.svg": 54396,
	"./img/channels/48pxIcons/Finland/Yle TV2.svg": 53143,
	"./img/channels/48pxIcons/Germany/ARD-alpha.svg": 19747,
	"./img/channels/48pxIcons/Germany/Amazon Prime DE.svg": 2947,
	"./img/channels/48pxIcons/Germany/BR.svg": 53028,
	"./img/channels/48pxIcons/Germany/DAZN.svg": 49433,
	"./img/channels/48pxIcons/Germany/Das Erste.svg": 92316,
	"./img/channels/48pxIcons/Germany/Einsfestival.svg": 5897,
	"./img/channels/48pxIcons/Germany/Eurosport 1.svg": 87230,
	"./img/channels/48pxIcons/Germany/Eurosport 2 Xtra.svg": 38223,
	"./img/channels/48pxIcons/Germany/Eurosport 2.svg": 35881,
	"./img/channels/48pxIcons/Germany/Eurosport Player DE.svg": 57835,
	"./img/channels/48pxIcons/Germany/HR.svg": 49981,
	"./img/channels/48pxIcons/Germany/Hamburg 1.svg": 16153,
	"./img/channels/48pxIcons/Germany/Kabel eins.svg": 33577,
	"./img/channels/48pxIcons/Germany/LAOLA1.svg": 72570,
	"./img/channels/48pxIcons/Germany/MDR.svg": 93749,
	"./img/channels/48pxIcons/Germany/Magenta Sport.svg": 96269,
	"./img/channels/48pxIcons/Germany/Motorvision TV.svg": 96438,
	"./img/channels/48pxIcons/Germany/N-TV.svg": 31230,
	"./img/channels/48pxIcons/Germany/NDR.svg": 94478,
	"./img/channels/48pxIcons/Germany/ProSieben Fun.svg": 3726,
	"./img/channels/48pxIcons/Germany/ProSieben MAXX.svg": 3258,
	"./img/channels/48pxIcons/Germany/RBB.svg": 88244,
	"./img/channels/48pxIcons/Germany/RTL II.svg": 80519,
	"./img/channels/48pxIcons/Germany/RTL NITRO.svg": 56748,
	"./img/channels/48pxIcons/Germany/RTL.svg": 86976,
	"./img/channels/48pxIcons/Germany/SAT.1 Gold.svg": 62662,
	"./img/channels/48pxIcons/Germany/SAT.1.svg": 68897,
	"./img/channels/48pxIcons/Germany/SPORT1+.svg": 77297,
	"./img/channels/48pxIcons/Germany/SPORT1.svg": 23681,
	"./img/channels/48pxIcons/Germany/SR Fernsehen.svg": 32233,
	"./img/channels/48pxIcons/Germany/SWR BW.svg": 13680,
	"./img/channels/48pxIcons/Germany/SWR RP.svg": 41384,
	"./img/channels/48pxIcons/Germany/SWR.svg": 90532,
	"./img/channels/48pxIcons/Germany/ServusTV Deutschland.svg": 20702,
	"./img/channels/48pxIcons/Germany/Sky Bundesliga 1.svg": 44933,
	"./img/channels/48pxIcons/Germany/Sky Bundesliga 2.svg": 84499,
	"./img/channels/48pxIcons/Germany/Sky Bundesliga 3.svg": 58840,
	"./img/channels/48pxIcons/Germany/Sky Bundesliga 4.svg": 11048,
	"./img/channels/48pxIcons/Germany/Sky Bundesliga 5.svg": 13602,
	"./img/channels/48pxIcons/Germany/Sky Bundesliga 6.svg": 62417,
	"./img/channels/48pxIcons/Germany/Sky Bundesliga 7.svg": 27346,
	"./img/channels/48pxIcons/Germany/Sky Bundesliga 8.svg": 40139,
	"./img/channels/48pxIcons/Germany/Sky Bundesliga 9.svg": 32599,
	"./img/channels/48pxIcons/Germany/Sky Bundesliga UHD.svg": 11742,
	"./img/channels/48pxIcons/Germany/Sky Bundesliga.svg": 83469,
	"./img/channels/48pxIcons/Germany/Sky Sport 1.svg": 8329,
	"./img/channels/48pxIcons/Germany/Sky Sport 10.svg": 29014,
	"./img/channels/48pxIcons/Germany/Sky Sport 11.svg": 25757,
	"./img/channels/48pxIcons/Germany/Sky Sport 2.svg": 78073,
	"./img/channels/48pxIcons/Germany/Sky Sport 3.svg": 13748,
	"./img/channels/48pxIcons/Germany/Sky Sport 4.svg": 26311,
	"./img/channels/48pxIcons/Germany/Sky Sport 5.svg": 4476,
	"./img/channels/48pxIcons/Germany/Sky Sport 6.svg": 98312,
	"./img/channels/48pxIcons/Germany/Sky Sport 7.svg": 65772,
	"./img/channels/48pxIcons/Germany/Sky Sport 8.svg": 92005,
	"./img/channels/48pxIcons/Germany/Sky Sport 9.svg": 92150,
	"./img/channels/48pxIcons/Germany/Sky Sport News.svg": 41412,
	"./img/channels/48pxIcons/Germany/Sky Ticket.svg": 71395,
	"./img/channels/48pxIcons/Germany/Sky Ultra HD.svg": 38762,
	"./img/channels/48pxIcons/Germany/Sportdeutschland.TV.svg": 69230,
	"./img/channels/48pxIcons/Germany/Sportdigital.svg": 59517,
	"./img/channels/48pxIcons/Germany/TV5MONDE Europe.svg": 20875,
	"./img/channels/48pxIcons/Germany/TVNOW.svg": 17698,
	"./img/channels/48pxIcons/Germany/WDR.svg": 89213,
	"./img/channels/48pxIcons/Germany/ZDF.svg": 52981,
	"./img/channels/48pxIcons/Germany/eSports1.svg": 94015,
	"./img/channels/48pxIcons/NewZealand/Duke.svg": 94198,
	"./img/channels/48pxIcons/NewZealand/ESPN 2.svg": 49384,
	"./img/channels/48pxIcons/NewZealand/ESPN.svg": 82185,
	"./img/channels/48pxIcons/NewZealand/Prime.svg": 95463,
	"./img/channels/48pxIcons/NewZealand/Rugby Channel.svg": 36063,
	"./img/channels/48pxIcons/NewZealand/SKY Sport Pop Up 1.svg": 34789,
	"./img/channels/48pxIcons/NewZealand/SKY Sport Pop Up 2.svg": 45692,
	"./img/channels/48pxIcons/NewZealand/Sky Arena.svg": 23201,
	"./img/channels/48pxIcons/NewZealand/Sky Sport 2.svg": 94147,
	"./img/channels/48pxIcons/NewZealand/Sky Sport 3.svg": 92957,
	"./img/channels/48pxIcons/NewZealand/Sky Sport 4.svg": 52081,
	"./img/channels/48pxIcons/NewZealand/Sky Sport 5.svg": 68339,
	"./img/channels/48pxIcons/NewZealand/Sky Sport 6.svg": 98120,
	"./img/channels/48pxIcons/NewZealand/Sky Sport 7.svg": 93761,
	"./img/channels/48pxIcons/NewZealand/Sky Sport 8.svg": 85285,
	"./img/channels/48pxIcons/NewZealand/Sky Sport 9.svg": 86616,
	"./img/channels/48pxIcons/NewZealand/Sky Sport Select.svg": 66754,
	"./img/channels/48pxIcons/NewZealand/Sky Sport.svg": 11766,
	"./img/channels/48pxIcons/NewZealand/Spark Sport.svg": 30316,
	"./img/channels/48pxIcons/NewZealand/TV5MONDE Pacific.svg": 82432,
	"./img/channels/48pxIcons/NewZealand/TVNZ+.svg": 98581,
	"./img/channels/48pxIcons/NewZealand/Trackside 1.svg": 74133,
	"./img/channels/48pxIcons/NewZealand/Trackside 2.svg": 81915,
	"./img/channels/48pxIcons/NewZealand/beIN SPORTS 2.svg": 10076,
	"./img/channels/48pxIcons/NewZealand/beIN SPORTS 3.svg": 18484,
	"./img/channels/48pxIcons/NewZealand/beIN SPORTS Pop-up 2.svg": 73570,
	"./img/channels/48pxIcons/NewZealand/beIN SPORTS Pop-up.svg": 74360,
	"./img/channels/48pxIcons/NewZealand/beIN SPORTS XTRA.svg": 64578,
	"./img/channels/48pxIcons/NewZealand/beIN SPORTS.svg": 50608,
	"./img/channels/48pxIcons/Norway/Betsafe NO.svg": 69438,
	"./img/channels/48pxIcons/Norway/Betsson NO.svg": 6262,
	"./img/channels/48pxIcons/Norway/Direktesport.svg": 49866,
	"./img/channels/48pxIcons/Norway/ESportsTV.svg": 49482,
	"./img/channels/48pxIcons/Norway/Eurosport 1.svg": 86008,
	"./img/channels/48pxIcons/Norway/Eurosport Norge.svg": 70469,
	"./img/channels/48pxIcons/Norway/Eurosport Player NO.svg": 26524,
	"./img/channels/48pxIcons/Norway/Eurosport Pluss 1.svg": 55120,
	"./img/channels/48pxIcons/Norway/Eurosport Pluss 2.svg": 48406,
	"./img/channels/48pxIcons/Norway/Eurosport Pluss 3.svg": 555,
	"./img/channels/48pxIcons/Norway/Eurosport Pluss 4-1.svg": 18310,
	"./img/channels/48pxIcons/Norway/Eurosport Pluss 4.svg": 19634,
	"./img/channels/48pxIcons/Norway/MAX.svg": 10150,
	"./img/channels/48pxIcons/Norway/NRK 1.svg": 23125,
	"./img/channels/48pxIcons/Norway/NRK 2.svg": 16631,
	"./img/channels/48pxIcons/Norway/NRK 3.svg": 45114,
	"./img/channels/48pxIcons/Norway/Strive Sport TV.svg": 10996,
	"./img/channels/48pxIcons/Norway/Strive Sport.svg": 6666,
	"./img/channels/48pxIcons/Norway/Strive.svg": 9691,
	"./img/channels/48pxIcons/Norway/TV 2 Sport 1.svg": 26146,
	"./img/channels/48pxIcons/Norway/TV 2 Sport 2.svg": 66001,
	"./img/channels/48pxIcons/Norway/TV 2 Sport Premium 2.svg": 24669,
	"./img/channels/48pxIcons/Norway/TV 2 Sport Premium 3.svg": 27539,
	"./img/channels/48pxIcons/Norway/TV 2 Sport Premium.svg": 37114,
	"./img/channels/48pxIcons/Norway/TV 2 Sportskanalen.svg": 12933,
	"./img/channels/48pxIcons/Norway/TV 2 Zebra.svg": 32265,
	"./img/channels/48pxIcons/Norway/TV 2.svg": 94088,
	"./img/channels/48pxIcons/Norway/TV2 Sumo.svg": 18675,
	"./img/channels/48pxIcons/Norway/TVNorge.svg": 53041,
	"./img/channels/48pxIcons/Norway/V Sport +.svg": 70740,
	"./img/channels/48pxIcons/Norway/V Sport Live 1.svg": 41380,
	"./img/channels/48pxIcons/Norway/V Sport Live 2.svg": 49553,
	"./img/channels/48pxIcons/Norway/V Sport Live 3.svg": 12065,
	"./img/channels/48pxIcons/Norway/V Sport Live 4.svg": 51037,
	"./img/channels/48pxIcons/Norway/V Sport Live 5.svg": 70472,
	"./img/channels/48pxIcons/Norway/VG+.svg": 43650,
	"./img/channels/48pxIcons/Norway/VOX.svg": 48375,
	"./img/channels/48pxIcons/Norway/Viaplay Kjøp.svg": 26006,
	"./img/channels/48pxIcons/Norway/Viasat 4.svg": 56579,
	"./img/channels/48pxIcons/Norway/Viasat Golf.svg": 86405,
	"./img/channels/48pxIcons/Norway/Viasport +.svg": 98409,
	"./img/channels/48pxIcons/Norway/Viasport 1.svg": 10421,
	"./img/channels/48pxIcons/Norway/Viasport 2.svg": 10904,
	"./img/channels/48pxIcons/Norway/Viasport 3.svg": 37809,
	"./img/channels/48pxIcons/Norway/Viasport Ultra HD.svg": 80102,
	"./img/channels/48pxIcons/Swedish/ATG.svg": 29088,
	"./img/channels/48pxIcons/Swedish/Aftonbladet Plus.svg": 79866,
	"./img/channels/48pxIcons/Swedish/Bet 365.svg": 5665,
	"./img/channels/48pxIcons/Swedish/C More Fotboll.svg": 58848,
	"./img/channels/48pxIcons/Swedish/C More Hockey.svg": 19733,
	"./img/channels/48pxIcons/Swedish/C More Live 1.svg": 49608,
	"./img/channels/48pxIcons/Swedish/C More Live 2.svg": 48374,
	"./img/channels/48pxIcons/Swedish/C More Live 3.svg": 73078,
	"./img/channels/48pxIcons/Swedish/C More Live 4 1.svg": 78130,
	"./img/channels/48pxIcons/Swedish/C More Live 4.svg": 4693,
	"./img/channels/48pxIcons/Swedish/Hajper.svg": 41049,
	"./img/channels/48pxIcons/Swedish/Kanal 5.svg": 44723,
	"./img/channels/48pxIcons/Swedish/Kanal 9.svg": 20808,
	"./img/channels/48pxIcons/Swedish/Kunskapskanalen.svg": 74504,
	"./img/channels/48pxIcons/Swedish/SVT 24.svg": 19218,
	"./img/channels/48pxIcons/Swedish/SVT Play.svg": 81087,
	"./img/channels/48pxIcons/Swedish/SVT1.svg": 74126,
	"./img/channels/48pxIcons/Swedish/SVT2.svg": 42946,
	"./img/channels/48pxIcons/Swedish/Sjuan.svg": 49245,
	"./img/channels/48pxIcons/Swedish/Sport Expressen.svg": 16529,
	"./img/channels/48pxIcons/Swedish/Sport Kanalen.svg": 49283,
	"./img/channels/48pxIcons/Swedish/TV 12.svg": 79918,
	"./img/channels/48pxIcons/Swedish/TV 4.svg": 83981,
	"./img/channels/48pxIcons/Swedish/TV 6.svg": 7935,
	"./img/channels/48pxIcons/Swedish/TV10.svg": 3802,
	"./img/channels/48pxIcons/Swedish/TV3 Sport.svg": 66293,
	"./img/channels/48pxIcons/Swedish/Tv 3.svg": 49080,
	"./img/channels/48pxIcons/Swedish/Tv4 play.svg": 9792,
	"./img/channels/48pxIcons/Swedish/V Sport ultra hd 1.svg": 62264,
	"./img/channels/48pxIcons/Swedish/V sport football 1.svg": 38731,
	"./img/channels/48pxIcons/Swedish/V sport hockey 1.svg": 86697,
	"./img/channels/48pxIcons/Swedish/VSport1.svg": 60162,
	"./img/channels/48pxIcons/Swedish/VSportMotor.svg": 37506,
	"./img/channels/48pxIcons/Swedish/VSport_premium.svg": 86797,
	"./img/channels/48pxIcons/Swedish/Viasat Sport Extra.svg": 50433,
	"./img/channels/48pxIcons/Swedish/sportbladet play.svg": 31839,
	"./img/channels/48pxIcons/UK/Amazon-Prime.svg": 22126,
	"./img/channels/48pxIcons/UK/BBC-Alba.svg": 22882,
	"./img/channels/48pxIcons/UK/BBC-Northern-Ireland.svg": 4671,
	"./img/channels/48pxIcons/UK/BBC-Red-Button.svg": 82785,
	"./img/channels/48pxIcons/UK/BBC-Scotland.svg": 76762,
	"./img/channels/48pxIcons/UK/BBC-Sport.svg": 34429,
	"./img/channels/48pxIcons/UK/BBC-Wales.svg": 9274,
	"./img/channels/48pxIcons/UK/BBC.svg": 21580,
	"./img/channels/48pxIcons/UK/BT-Sport-1.svg": 47838,
	"./img/channels/48pxIcons/UK/BT-Sport-2.svg": 26005,
	"./img/channels/48pxIcons/UK/BT-Sport-3.svg": 92699,
	"./img/channels/48pxIcons/UK/BT-Sport.svg": 68008,
	"./img/channels/48pxIcons/UK/Channel-4.svg": 74329,
	"./img/channels/48pxIcons/UK/Channel-5.svg": 18014,
	"./img/channels/48pxIcons/UK/Eleven-Sports.svg": 19674,
	"./img/channels/48pxIcons/UK/Eurosport.svg": 62767,
	"./img/channels/48pxIcons/UK/FreeSports.svg": 79844,
	"./img/channels/48pxIcons/UK/ITV-4.svg": 8658,
	"./img/channels/48pxIcons/UK/ITV-Sport.svg": 57209,
	"./img/channels/48pxIcons/UK/ITV.svg": 70045,
	"./img/channels/48pxIcons/UK/Premier-Sports.svg": 51858,
	"./img/channels/48pxIcons/UK/Prime-Video.svg": 49692,
	"./img/channels/48pxIcons/UK/Quest.svg": 77456,
	"./img/channels/48pxIcons/UK/Racing-TV.svg": 78020,
	"./img/channels/48pxIcons/UK/S4C.svg": 53983,
	"./img/channels/48pxIcons/UK/Sky-Sports-F1.svg": 76370,
	"./img/channels/48pxIcons/UK/Sky-Sports-Racing.svg": 8458,
	"./img/channels/48pxIcons/UK/Sky-Sports.svg": 10609,
	"./img/channels/48pxIcons/UK/Star-India.svg": 90350,
	"./img/channels/48pxIcons/UK/UEFA.svg": 59890,
	"./img/channels/48pxIcons/UK/Youtube.svg": 72469,
	"./img/channels/48pxIcons/default.svg": 92577,
	"./img/channels/Australian/10 bold 2.svg": 7733,
	"./img/channels/Australian/7Mate Brisbane.svg": 37874,
	"./img/channels/Australian/7Mate Melbourne.svg": 49318,
	"./img/channels/Australian/7Mate Sydney.svg": 87792,
	"./img/channels/Australian/7TWO 2.svg": 92498,
	"./img/channels/Australian/7TWO Brisbane.svg": 30497,
	"./img/channels/Australian/7TWO Melbourne.svg": 1822,
	"./img/channels/Australian/7TWO Perth.svg": 7598,
	"./img/channels/Australian/7TWO Sydney.svg": 11197,
	"./img/channels/Australian/7mate Adelaide 2.svg": 5972,
	"./img/channels/Australian/7mate Perth.svg": 27515,
	"./img/channels/Australian/9Gem 2.svg": 25727,
	"./img/channels/Australian/9go 2.svg": 5469,
	"./img/channels/Australian/ABC 2.svg": 94865,
	"./img/channels/Australian/ABC QLD.svg": 58845,
	"./img/channels/Australian/ABC SA.svg": 96222,
	"./img/channels/Australian/ABC VIC.svg": 16796,
	"./img/channels/Australian/ABC WA.svg": 31306,
	"./img/channels/Australian/Australia Plus 2.svg": 85316,
	"./img/channels/Australian/Channel 10 Brisbane.svg": 66873,
	"./img/channels/Australian/Channel 10 Melbourne.svg": 37897,
	"./img/channels/Australian/Channel 10 Perth.svg": 66116,
	"./img/channels/Australian/Channel 10 Sydney.svg": 51380,
	"./img/channels/Australian/Channel 10.svg": 66210,
	"./img/channels/Australian/Channel 7 Brisbane.svg": 69350,
	"./img/channels/Australian/Channel 7 Melbourne.svg": 5831,
	"./img/channels/Australian/Channel 7 Perth.svg": 42014,
	"./img/channels/Australian/Channel 7 Sydney.svg": 70091,
	"./img/channels/Australian/Channel 7.svg": 45101,
	"./img/channels/Australian/Channel 9 Brisbane.svg": 44972,
	"./img/channels/Australian/Channel 9 Melbourne.svg": 50197,
	"./img/channels/Australian/Channel 9 Perth.svg": 59635,
	"./img/channels/Australian/Channel 9 Sydney.svg": 94386,
	"./img/channels/Australian/Channel 9.svg": 61950,
	"./img/channels/Australian/Chelsea TV.svg": 86938,
	"./img/channels/Australian/ESPN.svg": 28117,
	"./img/channels/Australian/ESPN2.svg": 7093,
	"./img/channels/Australian/Epicentre.TV.svg": 69471,
	"./img/channels/Australian/Eurosport.svg": 33017,
	"./img/channels/Australian/Fox Cricket.svg": 56265,
	"./img/channels/Australian/Fox Footy.svg": 2551,
	"./img/channels/Australian/Fox League.svg": 91937,
	"./img/channels/Australian/Fox Sports 503.svg": 41419,
	"./img/channels/Australian/Fox Sports 505.svg": 1250,
	"./img/channels/Australian/Fox Sports 506.svg": 93248,
	"./img/channels/Australian/Fox Sports More.svg": 20454,
	"./img/channels/Australian/Fox Ultra HD.svg": 67062,
	"./img/channels/Australian/Kayo Sports.svg": 72158,
	"./img/channels/Australian/LFCTV.svg": 24798,
	"./img/channels/Australian/MUTV.svg": 72852,
	"./img/channels/Australian/Main Event.svg": 86262,
	"./img/channels/Australian/NITV.svg": 71589,
	"./img/channels/Australian/Netball Live.svg": 24324,
	"./img/channels/Australian/Optus sport.svg": 45452,
	"./img/channels/Australian/Prime.svg": 19853,
	"./img/channels/Australian/RAI Italia.svg": 27932,
	"./img/channels/Australian/Racing.com.svg": 73804,
	"./img/channels/Australian/SBS SA.svg": 13628,
	"./img/channels/Australian/SBS Sydney.svg": 55576,
	"./img/channels/Australian/SBS Viceland.svg": 40579,
	"./img/channels/Australian/SBS WA.svg": 11870,
	"./img/channels/Australian/SBS.svg": 42804,
	"./img/channels/Australian/SKY Racing 2.svg": 33848,
	"./img/channels/Australian/SKY Racing.svg": 73169,
	"./img/channels/Australian/Stan Sport Stan Sport.svg": 44361,
	"./img/channels/Australian/TV5MONDE Pacific.svg": 11245,
	"./img/channels/Australian/Telstra TV.svg": 13054,
	"./img/channels/Australian/beIN SPORTS 2.svg": 83172,
	"./img/channels/Australian/beIN SPORTS 3.svg": 79900,
	"./img/channels/Australian/beIN SPORTS.svg": 80211,
	"./img/channels/Danish/3-Max.svg": 75141,
	"./img/channels/Danish/3-Plus.svg": 5415,
	"./img/channels/Danish/3-Sport.svg": 95007,
	"./img/channels/Danish/6-eren.svg": 22425,
	"./img/channels/Danish/9-eren.svg": 89716,
	"./img/channels/Danish/C-More.svg": 99722,
	"./img/channels/Danish/Canal-8-Sport.svg": 75146,
	"./img/channels/Danish/DR1.svg": 72706,
	"./img/channels/Danish/DR2.svg": 79174,
	"./img/channels/Danish/DR3.svg": 80001,
	"./img/channels/Danish/Eurosport-1.svg": 142,
	"./img/channels/Danish/Eurosport-2.svg": 39198,
	"./img/channels/Danish/Eurosport-Player.svg": 9312,
	"./img/channels/Danish/Kanal-5.svg": 76491,
	"./img/channels/Danish/See.svg": 70649,
	"./img/channels/Danish/Strive.svg": 45211,
	"./img/channels/Danish/TV2-Sport.svg": 50909,
	"./img/channels/Danish/TV2.svg": 27855,
	"./img/channels/Danish/TV3-Sport-2.svg": 66726,
	"./img/channels/Danish/Viasat-Golf.svg": 21687,
	"./img/channels/Danish/Viasat-Xtra.svg": 36016,
	"./img/channels/Danish/Xee.svg": 42311,
	"./img/channels/Danish/dPlay.svg": 22452,
	"./img/channels/Danish/viaplay.svg": 6167,
	"./img/channels/NewZealand/Duke.svg": 12984,
	"./img/channels/NewZealand/ESPN 2.svg": 55488,
	"./img/channels/NewZealand/ESPN.svg": 16197,
	"./img/channels/NewZealand/Prime.svg": 79439,
	"./img/channels/NewZealand/Rugby Channel.svg": 95980,
	"./img/channels/NewZealand/SKY Sport Pop Up 1.svg": 41415,
	"./img/channels/NewZealand/SKY Sport Pop Up 2.svg": 25125,
	"./img/channels/NewZealand/Sky Arena.svg": 54793,
	"./img/channels/NewZealand/Sky Sport 10.svg": 79156,
	"./img/channels/NewZealand/Sky Sport 2.svg": 35738,
	"./img/channels/NewZealand/Sky Sport 3.svg": 78587,
	"./img/channels/NewZealand/Sky Sport 4.svg": 26255,
	"./img/channels/NewZealand/Sky Sport 5.svg": 16609,
	"./img/channels/NewZealand/Sky Sport 6.svg": 67219,
	"./img/channels/NewZealand/Sky Sport 7.svg": 25144,
	"./img/channels/NewZealand/Sky Sport 8.svg": 21076,
	"./img/channels/NewZealand/Sky Sport 9.svg": 1850,
	"./img/channels/NewZealand/Sky Sport Select.svg": 14920,
	"./img/channels/NewZealand/Sky Sport.svg": 52949,
	"./img/channels/NewZealand/Spark Sport.svg": 13173,
	"./img/channels/NewZealand/TV5MONDE Pacific.svg": 57451,
	"./img/channels/NewZealand/Trackside 1.svg": 76984,
	"./img/channels/NewZealand/Trackside 2.svg": 52737,
	"./img/channels/NewZealand/beIN SPORTS 2.svg": 83545,
	"./img/channels/NewZealand/beIN SPORTS Pop-up 2.svg": 17631,
	"./img/channels/NewZealand/beIN SPORTS Pop-up.svg": 44231,
	"./img/channels/NewZealand/beIN SPORTS.svg": 68613,
	"./img/channels/Swedish/Aftonbladet Plus.svg": 12682,
	"./img/channels/Swedish/Bet 365.svg": 71951,
	"./img/channels/Swedish/C More Fotboll.svg": 32264,
	"./img/channels/Swedish/C More Hockey.svg": 2609,
	"./img/channels/Swedish/C More Live 1.svg": 5090,
	"./img/channels/Swedish/C More Live 2.svg": 71807,
	"./img/channels/Swedish/C More Live 3.svg": 7690,
	"./img/channels/Swedish/C More Live 4.svg": 76449,
	"./img/channels/Swedish/Hajper.svg": 16770,
	"./img/channels/Swedish/Kanal 5.svg": 36573,
	"./img/channels/Swedish/Kanal 9.svg": 55878,
	"./img/channels/Swedish/Kunskapskanalen.svg": 39272,
	"./img/channels/Swedish/SVT 24.svg": 85680,
	"./img/channels/Swedish/SVT Play.svg": 36102,
	"./img/channels/Swedish/SVT1.svg": 94365,
	"./img/channels/Swedish/SVT2.svg": 40001,
	"./img/channels/Swedish/Sjuan.svg": 24285,
	"./img/channels/Swedish/Sport Expressen.svg": 31213,
	"./img/channels/Swedish/Sport Kanalen.svg": 10191,
	"./img/channels/Swedish/TV 12.svg": 35012,
	"./img/channels/Swedish/TV 4.svg": 14522,
	"./img/channels/Swedish/TV 6.svg": 7238,
	"./img/channels/Swedish/TV10.svg": 44283,
	"./img/channels/Swedish/TV3 Sport.svg": 1019,
	"./img/channels/Swedish/Tv 3.svg": 95829,
	"./img/channels/Swedish/Tv4 play.svg": 76602,
	"./img/channels/Swedish/VSport1.svg": 71510,
	"./img/channels/Swedish/VSportMotor.svg": 67261,
	"./img/channels/Swedish/VSport_premium.svg": 22753,
	"./img/channels/Swedish/Viasat Sport Extra.svg": 24953,
	"./img/channels/Swedish/sportbladet play.svg": 67199,
	"./img/channels/UK/Amazon-Prime.svg": 20792,
	"./img/channels/UK/BBC-Alba.svg": 10854,
	"./img/channels/UK/BBC-Northern-Ireland.svg": 32145,
	"./img/channels/UK/BBC-Red-Button.svg": 43671,
	"./img/channels/UK/BBC-Scotland.svg": 98167,
	"./img/channels/UK/BBC-Sport.svg": 57338,
	"./img/channels/UK/BBC-Wales.svg": 15449,
	"./img/channels/UK/BBC.svg": 60956,
	"./img/channels/UK/BT-Sport-1.svg": 8333,
	"./img/channels/UK/BT-Sport-2.svg": 95529,
	"./img/channels/UK/BT-Sport-3.svg": 15313,
	"./img/channels/UK/BT-Sport.svg": 46724,
	"./img/channels/UK/Channel-4.svg": 74859,
	"./img/channels/UK/Channel-5.svg": 64423,
	"./img/channels/UK/Eleven-Sports.svg": 84191,
	"./img/channels/UK/Eurosport.svg": 41714,
	"./img/channels/UK/FreeSports.svg": 42438,
	"./img/channels/UK/ITV-4.svg": 18600,
	"./img/channels/UK/ITV-Sport.svg": 79300,
	"./img/channels/UK/ITV.svg": 53721,
	"./img/channels/UK/Premier-Sports.svg": 79785,
	"./img/channels/UK/Prime-Video.svg": 58411,
	"./img/channels/UK/Quest.svg": 54224,
	"./img/channels/UK/Racing-TV.svg": 32840,
	"./img/channels/UK/S4C.svg": 80,
	"./img/channels/UK/Sky-Sports-F1.svg": 5000,
	"./img/channels/UK/Sky-Sports-Racing.svg": 39156,
	"./img/channels/UK/Sky-Sports.svg": 82390,
	"./img/channels/UK/Star-India.svg": 64831,
	"./img/channels/UK/UEFA.svg": 59290,
	"./img/channels/UK/Youtube.svg": 79250,
	"./img/channels/default.svg": 323,
	"./img/checkmark-icon.svg": 92044,
	"./img/close-icon.svg": 24514,
	"./img/close.svg": 32271,
	"./img/closeIcon.svg": 20868,
	"./img/custom-event.svg": 91617,
	"./img/dashboard-icon.svg": 95268,
	"./img/event-add-icon.svg": 30977,
	"./img/event-calendar.svg": 22886,
	"./img/event-delete-icon.svg": 8447,
	"./img/event-edit-icon.svg": 7445,
	"./img/event-star.svg": 97446,
	"./img/event-type-american-ball.svg": 12801,
	"./img/event-type-ball.svg": 5617,
	"./img/event-type-baseball.svg": 3208,
	"./img/event-type-custom.svg": 5713,
	"./img/event-type-hockey.svg": 28215,
	"./img/event-type-tennis.svg": 23122,
	"./img/event-type/american-football.svg": 79112,
	"./img/event-type/australian-football.svg": 43247,
	"./img/event-type/badminton.svg": 54891,
	"./img/event-type/baseball.svg": 80485,
	"./img/event-type/basketball.svg": 76903,
	"./img/event-type/cricket.svg": 83251,
	"./img/event-type/custom.svg": 94606,
	"./img/event-type/cycling.svg": 88256,
	"./img/event-type/fighting.svg": 76374,
	"./img/event-type/football.svg": 46304,
	"./img/event-type/gaa.svg": 27769,
	"./img/event-type/handball.svg": 61184,
	"./img/event-type/hockey.svg": 61239,
	"./img/event-type/horseracing.svg": 6038,
	"./img/event-type/other.svg": 41831,
	"./img/event-type/racing.svg": 57334,
	"./img/event-type/rugby-australian-football.svg": 23814,
	"./img/event-type/rugby.svg": 1190,
	"./img/event-type/tennis.svg": 96567,
	"./img/event-type/volleyball.svg": 49183,
	"./img/events-icon.svg": 89167,
	"./img/events/accept_reservation.svg": 84750,
	"./img/events/activity.svg": 37336,
	"./img/events/clone.svg": 84490,
	"./img/events/drink.svg": 23168,
	"./img/events/facebook.svg": 36751,
	"./img/events/instagram.svg": 11470,
	"./img/events/meetup.svg": 86728,
	"./img/events/more.svg": 47505,
	"./img/events/offer.svg": 74653,
	"./img/events/plus.svg": 80826,
	"./img/events/remove.svg": 35444,
	"./img/events/sportcompass-gray.svg": 88507,
	"./img/events/sportcompass.net.svg": 83962,
	"./img/events/sportcompass.svg": 92510,
	"./img/forward-arrow.svg": 5535,
	"./img/insights-icon.svg": 7017,
	"./img/leftArrow.svg": 42751,
	"./img/location.svg": 31537,
	"./img/logo-color-horizontal.svg": 7485,
	"./img/logo-without-text.svg": 93797,
	"./img/map.svg": 8132,
	"./img/message-dialog-config.svg": 17593,
	"./img/message-dialog-error.svg": 62764,
	"./img/message-dialog-success.svg": 40592,
	"./img/myschedule-header-icon.svg": 61773,
	"./img/new-logo.svg": 10065,
	"./img/notification.svg": 21151,
	"./img/promos-icon.svg": 15501,
	"./img/red-trashcan.svg": 59983,
	"./img/remove_image_icon.svg": 47331,
	"./img/reservation.svg": 97804,
	"./img/rightArrow.svg": 24717,
	"./img/scheduler.svg": 80961,
	"./img/searchIcon.svg": 19987,
	"./img/searchIconDisabled.svg": 39775,
	"./img/settings/Default-Bar-Cover.png": 4537,
	"./img/settings/fb-icon.svg": 16408,
	"./img/settings/filters-icon.svg": 21539,
	"./img/settings/filters.svg": 42250,
	"./img/settings/ig-icon.svg": 74651,
	"./img/settings/location-features/big-screen.svg": 32108,
	"./img/settings/location-features/bring-food.svg": 39332,
	"./img/settings/location-features/capacity.svg": 31927,
	"./img/settings/location-features/free-wifi.svg": 33553,
	"./img/settings/location-features/parking.svg": 16898,
	"./img/settings/location-features/screen.svg": 40779,
	"./img/settings/location-features/serves-food.svg": 29299,
	"./img/settings/location-image.svg": 87710,
	"./img/settings/parking.svg": 71216,
	"./img/settings/payment-icon.svg": 47147,
	"./img/settings/poster-settings-icon.svg": 3898,
	"./img/settings/settings.svg": 20357,
	"./img/settings/social-media-icon.svg": 94297,
	"./img/settings/social-media.svg": 23807,
	"./img/settings/user-company-icon.svg": 84423,
	"./img/settings/user-company.svg": 87486,
	"./img/settings/user-management-icon.svg": 11844,
	"./img/settings/user-preferences-icon.svg": 83563,
	"./img/settings/user-preferences.svg": 81883,
	"./img/settings/user-profile-icon.svg": 41452,
	"./img/settings/user-profile.svg": 57041,
	"./img/settings/widget-icon.svg": 59997,
	"./img/share-events-alert.svg": 86358,
	"./img/share-events-facebook.png": 80396,
	"./img/share-events-image-black.svg": 93872,
	"./img/share-events-image.svg": 78858,
	"./img/share-events-instagram.png": 76964,
	"./img/share-events-text-black.svg": 79420,
	"./img/share-events-text.svg": 13585,
	"./img/share-events-upload.svg": 28013,
	"./img/share-events-video-gray.svg": 53276,
	"./img/share-events-video.svg": 18180,
	"./img/smile-emoji-button.svg": 34032,
	"./img/upload.svg": 71968
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31106;